(function() {
	'use strict';

	var $infoBox = $('.js-question');
	$infoBox.on('click', function() {
		var $self = $(this),
			$target = $self,
			targetOpened = !!$target.hasClass('expand');

		// Close all boxes
		$infoBox.removeClass('expand');

		// Check current box for toggle
		if (targetOpened) {
			$target.removeClass('expand');
		} else {
			$target.addClass('expand');
		}
	});


			// THIS COULD BE REPLACED WITH <script src="j/sticky-bar.js"></script> AFTER FILE USES SNIPPET
	var detectedOS = avastGlobals.detect.os.name.toLowerCase(),
    $window = $(window),
    $buttons = $('.sticky-bar a'),
    waypoints = avm.require('avast.web.waypoints'),
    platformDetectionSelector = '#sticky-bar-platform-detect'

  $buttons.attr("tabindex",-1);

  if ($('.sticky-bar').length) {
    $window.on('resize scroll', function () {
      if (waypoints($('.sticky-waypoint'), null, null, true)) {
        $('.sticky-bar').addClass('is-sticky');
        $buttons.attr("tabindex",0);
      } else {
        $('.sticky-bar').removeClass('is-sticky');
        $buttons.attr("tabindex",-1);
      }
    });

    $buttons.filter('[href^="#"]').on('click', function(e) {
      e.preventDefault()
      var targetSection = $($(this).attr('href'))
      $('html, body').animate({
        scrollTop: targetSection.length ? targetSection.offset().top : 0,
      })
    })
  }


  if ($(platformDetectionSelector).length) {
    var app = new Vue({
      el: platformDetectionSelector,
      delimiters: ["<%", "%>"],
      data: {
        detectedOS: detectedOS,
      }
    })
  }
  // end of possible code removal


})();

// carousel controllers
if ($('.slider-sliderSliNotiSecSm').length > 0) {
	var sliderInfNotiSecMed = tns({
		"container": ".slider-sliderSliNotiSecSm",
		"controlsContainer": ".slider-sliderSliNotiSecSm-controls",
		"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"controls": false,
		"navPosition": "bottom",
		"mouseDrag": true,
		"speed": 400,
		"center": false,
		"slideBy": 1,
		"fixedWidth": 250,
		"gutter": 16,
		"loop": false,
		"responsive": {
			"768": {
				"slideBy": 1,
				"controls": false,
				"fixedWidth": 316,
				"gutter": 32
			},
			"1280": {
				"slideBy": 1,
				"controls": true,
				"fixedWidth": 316,
				"gutter": 64
			},
			"1600": {
				"slideBy": 1,
				"controls": true,
				"fixedWidth": 316,
				"gutter": 64
			}
		}
	});
}

if ($('.slider-sliderSliNotiSecSmFeatures').length > 0) {
	var sliderInfNotiSecMed = tns({
		"container": ".slider-sliderSliNotiSecSmFeatures",
		"controlsContainer": ".slider-sliderSliNotiSecSmFeatures-controls",
		"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"controls": false,
		"navPosition": "bottom",
		"mouseDrag": true,
		"speed": 400,
		"center": false,
		"slideBy": 1,
		"fixedWidth": 250,
		"gutter": 16,
		"loop": false,
		"responsive": {
			"768": {
				"slideBy": 1,
				"controls": false,
				"fixedWidth": 316,
				"gutter": 32
			},
			"1280": {
				"slideBy": 1,
				"controls": true,
				"fixedWidth": 316,
				"gutter": 64
			},
			"1600": {
				"slideBy": 1,
				"controls": true,
				"fixedWidth": 290,
				"gutter": 64
			}
		}
	});
}
